import script from "./TransactionDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetailModal.vue?vue&type=style&index=0&id=eccae9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eccae9f8"]])

export default __exports__